import DOMPurify from "dompurify";

// Program descriptions are HTML from the ops rich-text editor (Quill). They are
// written by tenant admins but rendered inside every member's session, so
// only formatting markup survives: no scripts, handlers, iframes, forms or
// inline styles.
const OPTIONS = {
  ALLOWED_TAGS: [
    "p", "br", "strong", "b", "em", "i", "u", "s", "strike", "sub", "sup",
    "ol", "ul", "li", "a", "span", "div", "h1", "h2", "h3", "h4",
    "blockquote", "pre", "code",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "class"],
  ALLOW_DATA_ATTR: false,
};

let hookInstalled = false;
function installLinkHook() {
  if (hookInstalled) return;
  hookInstalled = true;
  // Links leave the mini app in a new tab and can't reach back (window.opener).
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A" && node.hasAttribute("href")) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
}

export function sanitizeHelpHtml(html) {
  installLinkHook();
  return DOMPurify.sanitize(String(html ?? ""), OPTIONS);
}
